import { usePagination } from './usePagination';

export type PaginationQueryVariables = {
  skip: number;
  first: number;
};

export const usePaginationQueryVariables = (): PaginationQueryVariables => {
  const { page, rowsPerPage } = usePagination();

  return {
    skip: page * rowsPerPage,
    first: rowsPerPage,
  };
};
